

 <template>
  <section class="purchase-page">
  <div class="banner-container">
    <img :src="bannerUrl" alt="Banner" class="banner" />
   </div>


    <div class="header">
      <button class="back-btn" @click="goBack">
        <span class="material-symbols-outlined">arrow_back_ios</span>
      </button>
      <h2 class="title">Customer Details</h2>
      <div class="progress-dots">
        <span></span>
        <span class="active"></span>
        <span></span>
      </div>
    </div>

    <div class="form-card">
      <form @submit.prevent="nextStep">
        <label>Customer Name<span class="required-star">*</span>
          <input v-model="form.customerName" @input="validateCustomerName" />
          <small v-if="errors.customerName">{{ errors.customerName }}</small>
        </label>

        
       <label>Customer Email<span class="required-star">*</span>
        <input v-model="form.customerEmail" @input="validateCustomerEmail" />
        <small v-if="errors.customerEmail">{{ errors.customerEmail }}</small>
      </label>


        <label>Address 1<span class="required-star">*</span>
          <input v-model="form.address1" @input="validateAddress1" />
          <small v-if="errors.address1">{{ errors.address1 }}</small>
        </label>

        <label>Address 2<span class="required-star">*</span>
          <input v-model="form.address2" @input="validateAddress2" />
          <small v-if="errors.address2">{{ errors.address2 }}</small>
        </label>

        <label>Pin code<span class="required-star">*</span>
          <input v-model="form.pincode" @input="onPinCodeChange" />
          <small v-if="errors.pincode">{{ errors.pincode }}</small>
        </label>

        <label>City
          <input v-model="form.city" readonly placeholder="Auto filled based on Pin code" />
        </label>

        <label>State
          <input v-model="form.state" readonly placeholder="Auto filled based on Pin code" />
        </label>
      </form>

      <p class="note-text">Note: Your gift will be delivered to this address</p>    </div>

    <div class="validate-wrapper">
      <button class="next-btn" @click="nextStep" :disabled="hasErrors">Next</button>
    </div>

      <div class="footer" >
        Powered by Elevatoz PVT LTD
      </div>
  </section>
</template>

<script>
import axios from "axios";


export default {
  name: "CustomerDetails",
  props: {
    initialData: { type: Object, default: () => ({}) } // optional prefilled data
  },
  data() {
    return {
       bannerUrl: process.env.VUE_APP_BANNER_URL,
      form: {
        customerName: this.initialData.customerName || '',
        customerEmail: this.initialData.customerEmail || '',
        address1: this.initialData.address1 || '',
        address2: this.initialData.address2 || '',
        pincode: this.initialData.pincode || '',
        city: this.initialData.city || '',
        state: this.initialData.state || ''
      },
      errors: {
        customerName: '',
        customerEmail: '',
        address1: '',
        address2: '',
        pincode: ''
      }
    };
  },
  computed: {
    hasErrors() {
      return Object.values(this.errors).some(err => err);
    }
  },
created() {
    if (sessionStorage.getItem("comingFromGiftPage")) {
      const saved = sessionStorage.getItem("customerDetails");
      if (saved) {
        Object.assign(this.$data, JSON.parse(saved));
      }
      sessionStorage.removeItem("comingFromGiftPage");
    }
  },


  methods: {
   
    goBack() {
      // this.$emit('go-back'); // navigate to previous page

    sessionStorage.setItem("comingFromCustomerPage", true);
    this.$emit("go-back");
    },
  

    nextStep() {
      this.validateCustomerName();
      this.validateCustomerEmail();
      this.validateAddress1();
      this.validateAddress2();
      this.validatePincode();

      if (!this.hasErrors) {
        // Emit validated data to parent
        this.$emit('validated', { ...this.form });
      }
    },

    validateCustomerName() {
      const val = this.form.customerName.trim();
      if (!val) this.errors.customerName = "Required";
      else if (!/^[a-zA-Z ]+$/.test(val)) this.errors.customerName = "Only letters allowed";
      else if (val.length < 2) this.errors.customerName = "Min 2 characters";
      else this.errors.customerName = "";
    },

    validateCustomerEmail() {
      const val = this.form.customerEmail.trim();
      if (!val) {
        this.errors.customerEmail = "Required";
        return;
      }
      const emailRegex = /^[A-Za-z0-9._%+-]+@([A-Za-z]{2,}(\.[A-Za-z]{1,2})?\.[A-Za-z]{2,})$/;
      this.errors.customerEmail = emailRegex.test(val) ? "" : "Invalid email format";
    },

    validateAddress1() {
      const val = this.form.address1.trim();
      if (!val) this.errors.address1 = "Required";
      else if (val.length < 3) this.errors.address1 = "Min 3 characters";
      else this.errors.address1 = "";
    },

    validateAddress2() {
      const val = this.form.address2.trim();
      if (!val) this.errors.address2 = "Required";
      else if (val.length < 3) this.errors.address2 = "Min 3 characters";
      else this.errors.address2 = "";
    },

    validatePincode() {
      const regex = /^[1-9][0-9]{5}$/;
      if (!this.form.pincode) this.errors.pincode = "Required";
      else if (!regex.test(this.form.pincode)) this.errors.pincode = "Invalid pin code";
      else this.errors.pincode = "";
    },

    onPinCodeChange() {
      this.validatePincode();
      if (/^[1-9][0-9]{5}$/.test(this.form.pincode)) {
        this.fillCityState();
      } else {
        this.form.city = "";
        this.form.state = "";
      }
    },

    async fillCityState() {
      const pin = this.form.pincode.trim();
      try {
        const response = await axios.post(
          "https://loyalty.elevatozrewards.com/wp-json/el/v1/lookup/pincode",
          { pincode: pin },
          {
            headers: {
              "api-key": "a9298379-58ab-11ef-a68b-b646c323312d",
              "Content-Type": "application/json"
            }
          }
        );
        const data = response.data?.response?.data?.[0];
        if (data) {
          this.form.city = data.pincodeCity || '';
          this.form.state = data.pincodeState || '';
        } else {
          this.form.city = '';
          this.form.state = '';
        }
      } catch (err) {
        console.error("Pincode API error:", err);
        this.form.city = '';
        this.form.state = '';
      }
    }
  }
};
</script>

<style scoped>
.purchase-page {
  font-family: 'Poppins', sans-serif;
  padding: 15px;
  max-width: 400px;
  margin: 0 auto;
}

.banner img {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 15px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.back-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.title {
  font-weight: 500;
  font-size: 1.3rem;
  flex: 1;
  text-align: left;
}

.progress-dots {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  width: 100%;
}

.progress-dots span {
  width: 10px;
  height: 10px;
  background: #ccc;
  border-radius: 50%;
  display: inline-block;
}

.progress-dots span.active {
  background: #006488;
}

.form-card {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

form label {
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
}

input {
  width: 100%;
  padding: 8px 10px;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

small {
  color: red;
  font-size: 12px;
}

.validate-wrapper {
  margin-top: 15px;
}

.next-btn {
  width: 40%;
  padding: 12px;
  background: #00688B;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

.next-btn:disabled {
  background: #005575;
  cursor: not-allowed;
}

.next-btn:hover:enabled {
  background: #005575;
}
.required-star {
    color: red;
  }


.footer {
  margin-top: auto; 
  font-size: 0.6rem;
  color: #888;
  text-align: center;
}
.note-text {
  font-family: 'Inter'f;
  font-weight: 600; 
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  color:  #D00000;

  margin-top: 5px;
  text-align: center;
}
@media (max-width: 480px) {
  .purchase-page {
    padding: 10px;
  }
}
</style>